/**
 * @fileoverview NavItems - Navigation menu configuration
 * 
 * Provides centralized navigation menu configuration for:
 * - Primary navigation items
 * - Route paths and labels
 * - Menu ordering and structure
 * - Consistent navigation across application
 * - Easy maintenance and updates
 * 
 * @module NavItems
 * 
 * @author By John Bellew - Infinia.ie - last updated 10/07/2025
 */

/**
 * Navigation Items Configuration
 * 
 * Defines the primary navigation menu structure with paths and labels.
 * 
 * @type {Array<{path: string, label: string}>}
 */
export const navigationItems = [
  { path: '/Spotlight', label: 'Spotlight' },
  { path: '/PolicyRegulatory', label: 'Policy & Regulatory' },
  { path: '/NewsRoom', label: 'News Room' },
  { path: '/WorkingGroups', label: 'Working Groups' },
  { path: '/CapabilityInnovation', label: 'Capability & Innovation' },
  { path: '/CouncilCorner', label: 'Council Corner' },
  { path: '/Representation', label: 'Representation' },
  { path: '/Events', label: 'Events' },
  { path: '/Daire', label: 'Daire' }
];

export default navigationItems;
